<!-- @format -->
<script lang="ts">
  import type { ManageAPI } from "~/manage-api/types";
  import type { StoresKey } from "~/stores";
  import { getStoresContext } from "~/stores";

  export let request_store_key: StoresKey;
  export let category: {name: string, stores: ManageAPI.Store[] };

  const { scdata, reverse_router } = getStoresContext(request_store_key);
</script>

{#if category}
  <div class="store-category col-12 col-lg-4 mb-5">
    <strong>{category.name}</strong>
    {#each category.stores as store}
      <a class="mb-3 d-block link" href= {$reverse_router.routeStore(store, $scdata)}>
        {store.name}
      </a>
    {/each}
  </div>
{/if}

<style lang="scss">
  .store-category {
    padding: 0 30px;
    @media screen and (max-width: 768px) {
      text-align: center;
    }
  }
  strong {
    display: block;
    margin: 15px 0;
    font-size: 30px;
    font-weight: 500;
    line-height: 22px;
  }
</style>
